export const WORDS = [
    'drive',
    'tyres',
    'fduct',
    'perez',
    'vettel',
    'toto',
    'max',
    'crash',
    'bwoah',
    'haas',
    'lewis',
    'george',
    'yuki',
    'korea',
    'race',
    'paddock',
    'practice',
    'quali',
    'bahrain',
    'stowe',
    'abbey',
    'senna',
    'pedro',
    'charles',
    'checo',
    'saudi',
    'massa',
    'ocon',
    'frank',
    'williams',
    'start',
    'ayrton',
    'ickx',
    'wheel',
    'ferme',
    'plank',
    'poles',
    'prime',
    'inter',
    'visor',
    'races',
    'teams',
    'tests',
    'clean',
    'dirty',
    'track',
    'grain',
    'brake',
    'power',
    'green',
    'black',
    'white',
    'flags',
    'steer',
    'rules',
    'fluid',
    'delta',
    'drift',
    'motor',
    'sport',
    'cycle',
    'bottas',
    'pouhon',
    'softs',
    'hards',
    'slick',
    'kerbs',
    'modes',
    'party',
    'stops',
    'walls',
    'poles',
    'leads',
    'stint',
    'quick',
    'setup',
    'wings',
    'grand',
    'night',
    'board',
    'point',
    'score',
    'units',
    'front',
    'rears',
    'pilot',
    'traps',
    'cover',
    'check',
    'burns',
    'drags',
    'nomex',
    'chase',
    'times',
    'zhou',
    'ertl',
    'draft',
    'lines',
    'inlap',
    'paint',
    'lanes',
    'flaps',
    'shunt',
    'areas',
    'specs',
    'spins',
    'turns',
    'light',
    'stand',
    'shift',
    'gears',
    'pedal',
    'curve',
    'decal',
    'kerbs',
    'leclerc',
    'speed',
    'turbo',
    'spark',
    'valve',
    'train',
    'wires',
    'pipes',
    'shaft',
    'radio',
    'gauge',
    'level',
    'panel',
    'seats',
    'quali',
    'cable',
    'label',
    'screw',
    'rivet',
    'oring',
    'space',
    'dummy',
    'slide',
    'magic',
    'floor',
    'fibre',
    'spark',
    'cliff',
    'first',
    'spark',
    'shunt',
    'suits',
    'title',
    'first',
    'third',
    'fifth',
    'sixth',
    'ninth',
    'tenth',
    'glove',
    'drink',
    'place',
    'names',
    'copse',
    'rouge',
    'monza',
    'imola',
    'miami',
    'lesmo',
    'sochi',
    'sainz',
    'lando',
    'clark',
    'lauda',
    'ferrari',
    'james',
    'prost',
    'eddie',
    'stowe',
    'manor',
    'march',
    'sachs',
    'clark',
    'damon',
    'lance',
    'albon',
    'nigel',
    'glock',
    'gasly',
    'checo',
    'perez',
    'nigel',
    'wolff',
    'allen',
    'david',
    'damon',
    'aguri',
    'india',
    'aston',
    'alpha',
    'tauri',
    'brawn',
    'honda',
    'lotus',
    'spoon',
    'tabac',
    'tilke',
    'grove',
    'bruce',
    'abbey',
    'diniz',
    'newey',
    'rosso',
    'sutil',
    'buemi',
    'alesi',
    'kvyat',
    'multi'
]

